import { IDeleteAtividadeObraUseCase } from "../../../presentation/useCases/delete/delete_atividade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteAtividadeObraUseCase
 */

export class DeleteAtividadeObraUseCase implements IDeleteAtividadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteAtividadeObra(
    idAtividadeObra: number,
  ): Promise<void> {
    await this.repository.deleteAtividadeObra(idAtividadeObra);
  }
}
